module.exports = __webpack_public_path__ + "static/logo-light-1d619b11bed652e440fa067b1de63d5b.svg";